// The authoritative source for these values -- record-payment-input.ts's Zod schema enforces
// them server-side, and any client-side form validation should read from here rather than
// hardcoding a copy that can silently drift from what the server actually accepts.
export const SALES_ORDER_PAYMENT_CONSTRAINTS = {
    salesOrder: { label: 'Sales order' },
    amount: { label: 'Amount', max: 1_000_000_000 },
    paymentMethod: { label: 'Payment method' },
    paymentType: { label: 'Payment type', requiredMessage: 'Type is required.' },
    paymentDate: {
        label: 'Payment date',
        min: new Date('2000-01-01T00:00:00.000Z'),
        maxDaysInFuture: 90,
    },
    reversalReason: { label: 'Reversal reason', max: 2000 },
    referenceNumber: { label: 'Reference number', max: 100 },
    notes: { label: 'Notes', max: 2000 },
};
//# sourceMappingURL=payment-constraints.js.map